import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'
import { toast } from "react-toastify";

import Form from './Form'
import FormUpload from './FormUpload'
import Detail from './Detail'
import ActionGet from '../../store/action/FlowTemplate/Fetch'
import ActionDelete from '../../store/action/DivisionSetting/Delete'

import "../../source/util.css"
import { IsView, IsUpload, IsCreate } from '../../store/constants'
import CustomGrid from "../../infra/components/grid/custom-grid-without-search";
import TextInputField from '../../infra/components/formInput/CustomTextInput'
import ComboboxInput from "../../infra/components/formInput/ComboboxInput"
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllDivision from '../../store/action/Division/FetchAll';
import ActionGetAllSender from '../../store/action/Sender/FetchAll';
import ActionPublish from '../../store/action/FlowTemplate/Publish';
import Swal from "sweetalert2";


class Page extends Component {
    constructor(props) {
        super(props)
        this.state = {
            title: "Division",
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            }),
            formSearch: fromJS({
                "search": ""
            }),
            searchForm: fromJS({
                "client-id": '',
                "division-id": '',
                "sender-id": '',
                "flow-name": "",
            }),
            search: fromJS([
                { widthClass: 'col-sm-12', id: 'search', placeholder: 'Search', label: '', value: '' },
            ]),
            columns: [
                { className: "col-sm-4", field: "flow_id", caption: "Flow Id", allowSearch: true },
                { className: "col-sm-4", field: "flow_name", caption: "Flow Name", allowSearch: true },
                { className: "col-sm-3", field: "namespace", caption: "Name Space", allowSearch: true },
                { className: "col-sm-2", field: "file_status", caption: "File Flow", allowSearch: true },
                { className: "col-sm-2", field: "status_publish", caption: "Published", allowSearch: true },
                { 
                    className: "col-sm-1", 
                    cfield: "action", 
                    caption: "Actions",
                    allowEdit: false,
                    allowDelete: false,
                    custom: fromJS([
                        {
                        id: 'Publish',
                        icon: 'cloud_upload',
                        label: 'Publish Flow',
                        className: 'btn-trans btn-sm waves-effect text-success ',
                        },
                        {
                        id: 'Upload',
                        icon: 'drive_folder_upload',
                        label: 'Upload File Flow',
                        className: 'btn-trans btn-sm waves-effect text-success',
                        },
                    ]),
                }
            ],
            errors: fromJS({})
        };

        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handleUploadClicked = this.handleUploadClicked.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handleCustomAction = this.handleCustomAction.bind(this);
    }

    componentDidMount() {
        this.props.actionGetAllClient()
    }

    handleSearch(obj) {
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleChange(field, value, label) {
        var formVal = this.state.searchForm;
        formVal = formVal.set(field, value);

        if (field === 'client-id') {
            this.setState({ client_id: value })
            this.props.actionGetAllDivision(value, 'List Upload');
            this.props.actionGetAllSender(value);
        }

        if (field === 'division-id') {
            formVal = formVal.set('sender-id', '')
            this.setState({ searchForm: formVal })
            this.props.actionGetAllSender(this.state.client_id, value);
        }

        this.setState({ searchForm: formVal })
    }

    handleCancelForm(refresh) {
        if (refresh) {
            //new
            this.handleFindSearch(1);
        }
        this.setState({
            form: fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleNew() {
        this.setState({
            form: fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.setState({
            form:  fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    handleUploadClicked(value) {
        this.setState({
            form:  fromJS({
                show: true,
                actionType: IsUpload,
                item: value
            })
        })
    }

    handleOnBindCustomAction(actionId, row) {
        if (actionId === 'Upload') {
            if (row.get('file_status') === 'false') {
                return true;
            }
        }else if (actionId === 'Publish') {
            if (row.get('status_publish') === 'false' && row.get('file_status') === 'true') {
                return true;
            }
        }
        return false
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    async handleCustomAction(id, row) {
        var flow_id = row.get('flow_id')
        switch (id) {
          case ('Publish'):
            var response = await this.props.actionPublish(flow_id)
            if (response.ok) {
              toast.success('Success Publish Flow Template', toast.POSITION.BOTTOM_RIGHT)
              this.handleFindSearch(1)
            } else {
              //toast.error('Process Failed!', toast.POSITION.BOTTOM_RIGHT)
            }
            break
          case 'Upload':
            this.handleUploadClicked(row);
            break
    
          default:
        }
      }

    refreshGrid(page, search) {
        //new
        this.handleFindSearch(page);
    }

    showContent() {
        var form = this.state.form;


        if (form.get('show') && form.get('actionType') === IsCreate) {
            return (
                <Form
                    actionType={form.get('actionType')}
                    item={form.get('item')}
                    handleCancelForm={this.handleCancelForm}
                    handleSubmitOnForm={this.handleSubmitOnForm}
                >
                </Form>
            )
        } else if (form.get('show') && form.get('actionType') === IsUpload) {
            return (
                <FormUpload
                    actionType={form.get('actionType')}
                    item={form.get('item')}
                    handleCancelForm={this.handleCancelForm}
                    handleSubmitOnForm={this.handleSubmitOnForm}
                >
                </FormUpload>
            )
        } else if (form.get('show') && form.get('actionType') === IsView) {
            return (
                <Detail
                    actionType={form.get('actionType')}
                    item={form.get('item')}
                    handleCancelForm={this.handleCancelForm}
                    handleSubmitOnForm={this.handleSubmitOnForm}
                >
                </Detail>
            )
        } else {
            const items = this.props.flowTemplateAll ? fromJS(this.props.flowTemplateAll) : fromJS({});
            return (
                <CustomGrid
                    title="Division"
                    columns={this.state.columns}
                    items={items}
                    search={this.state.search}
                    handleSearch={this.handleSearch}
                    handlePageChanged={this.handlePageChanged}
                    handleViewClicked={this.handleViewClicked}
                    handleOnBindCustomAction={this.handleOnBindCustomAction}
                    handleCustomAction={this.handleCustomAction}
                >
                </CustomGrid>
            )
        }
    }

    handleFind() {
        this.handleFindSearch(1);
    }

    handleFindSearch(page) {
        const { searchForm } = this.state;
        let client_id = searchForm.get('client-id');
        let division = searchForm.get('division-name');
        let sender = searchForm.get('sender-id');
        let flow_name = searchForm.get('flow-name');
        this.props.actionGet(page, this.state.sortForm, client_id, division, sender, flow_name);
    }

    render() {
        const { form, errors, searchForm } = this.state;
        const title = form.get('show') ? (form.get('actionType') === IsCreate ? "Add Flow Template" : "Edit Division") : "Flow Template";
        const classHide = title == "Flow Template" ? 'card show' : 'card hidden';

        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        {title}
                    </h4>
                </div>
                <div className={classHide}>
                    <div className="body">
                        <div className="row">
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='client-id'
                                    value={searchForm.get('client-id')}
                                    options={fromJS({
                                        'source': this.props.clientall,
                                        'value': 'client-id',
                                        'label': 'client-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Client"
                                    disabled={this.state.disrest}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='division-id'
                                    value={searchForm.get('division-id')}
                                    options={fromJS({
                                        'source': this.props.divisionall,
                                        'value': 'division-id',
                                        'label': 'division-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Division"
                                    disabled={this.state.disrest}
                                    // disabled={this.state.disabled}
                                    hasError={errors.has('division-id')}
                                />
                            </div>
                            <div className="col-sm-6">
                                <ComboboxInput
                                    field='sender-id'
                                    value={searchForm.get('sender-id')}
                                    options={fromJS({
                                        'source': this.props.senderall,
                                        'value': 'sender-id',
                                        'label': 'sender-name'
                                    })}
                                    onChange={(field, value, label) => this.handleChange(field, value, label)}
                                    placeholder="Sender"
                                    disabled={this.state.disrest}
                                    // disabled={this.state.disabled}
                                    hasError={errors.has('sender-id')}
                                />
                            </div>
                            <div className="col-sm-6">
                                <TextInputField
                                    className="form-control"
                                    field={'flow-name'}
                                    value={searchForm.get('flow-name')}
                                    onChange={(field, value) => this.handleChange(field, value)}
                                    placeholder="Flow Name"
                                />
                            </div>
                        </div>
                        <div className="row no-margin-bottom" >
                            <div className="col-sm-2">
                                <button type="button"
                                    className="btn btn-wide btn-success"
                                    onClick={this.handleFind}>
                                    Search
                                </button>
                            </div>
                            <div className="col-sm-1"></div>
                            <div className="col-sm-2">
                                <button type="button"
                                    className="btn btn-wide btn-success content-add"
                                    onClick={this.handleNew}>
                                    <i className="material-icons">{'add'}</i>{'Add'}
                                </button>
                            </div>

                        </div>
                    </div>

                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            clientall: state.user.clientall,
            divisionall: state.user.divisionall,
            senderall: state.user.senders,
            flowTemplateAll: state.user.flowTemplateAll,
        }
    },
    dispatch => bindActionCreators({
        actionGet: ActionGet,
        actionDelete: ActionDelete,
        actionGetAllClient: ActionGetAllClient,
        actionGetAllDivision: ActionGetAllDivision,
        actionGetAllSender: ActionGetAllSender,
        actionPublish: ActionPublish,
    }, dispatch),
)(Page);